import React, { useState } from "react";
import Password from "../../../services/password";
import { IconContext } from "react-icons";
import { FaSpinner } from "react-icons/fa";
import FormStep from "../../../components/FormStep";
import { toast } from "react-toastify";
import Header from "../../../components/Header";

const Request = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [email, setEmail] = useState("");

    const handleOnChange = (event) => {
        setEmail(event.target.value);
    };

    const changePassword = async () => {
        try {
            setIsLoading(true);

            const res = await Password.getPassword(email);

            if (res.status === 200) {
                setIsLoading(false);
                return toast.success("Um email foi enviado ao destinatário com as instruções seguintes");
            }
        } catch (e) {
            setIsLoading(false);
            return toast.error(`Email não foi identificado: ${e.message}`);
        }
    };

    return (
        <>
            <Header />
            <FormStep background="linear-gradient(180deg, #F1F1F1 0%, #F7F6F6 25.17%, rgba(247, 246, 246, 0) 100%)">
                <div className="mt-50 pt-30 pl-40">
                    <span className="f-22">Informe o email cadastrado</span>
                </div>
                <div className="mt-30">
                    <span className="f-12 t-gray pl-40">E-mail</span>
                </div>
                <div className="step-body">
                    <div className="nt-20">
                        <input
                            className="t-gray-light"
                            type="text"
                            id="email"
                            placeholder="Digite o seu e-mail"
                            name="email"
                            value={email}
                            onChange={handleOnChange}
                        />
                    </div>
                </div>
                <div className="mt-30 pr-30 pl-30 nt-20 text-center">
                    <button
                        className="btn btn-full btn-purple"
                        type="button"
                        onClick={changePassword}
                        style={{ padding: "15px", borderRadius: "32px", cursor: "pointer", textTransform: "uppercase", color: "#fff" }}
                    >
                        Enviar a senha
                    </button>
                    {isLoading === true ? (
                        <IconContext.Provider value={{ size: "22px", className: "spin" }}>
                            <FaSpinner />
                        </IconContext.Provider>
                    ) : null}
                </div>
            </FormStep>
        </>
    );
};

export default Request;
